

import { redirect } from "react-router-dom";
import { getShortIdData } from "../utils/Common";

export const PublicRoute = async ({ params }) => {
  const token = localStorage.getItem('token');
  const lastCompany = localStorage.getItem('company_id');
  const lastEmail = localStorage.getItem('email');

  if (token) {
    if ((window.location.pathname?.includes('/signin_with_otp') || window.location.pathname?.includes('/signup')) && params.short_url) {
      try {
        const result = await getShortIdData(params.short_url);
        console.log("🚀 ~ PublicRoute ~ result:", result)
        if (result?.status && result?.data?.company_id) {
          const newCompanyId = result.data.company_id;
          const newEmail = result.data.email;

          if ((lastCompany !== newCompanyId) && (lastEmail === newEmail)) {
            console.log("🔄 Company changed. Stay on this page, allow Login to call switch API.");
            return null; // Allow <Login /> to load
          }

          // Same company → redirect
          return redirect("/connect");
        }

        // If short_url is invalid or error occurred
        console.warn("❌ Invalid short URL.");
        return redirect("/connect");
      } catch (err) {
        console.error("🔥 Error in getShortIdData:", err);
        return redirect("/connect");
      }
    } else {
      return redirect("/connect");
    }
  }

  // No token → allow login
  return null;
};

export const PublicURL = async () => {
  return null;
};

